import React from "react";

export const ArrowheadDown: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M4.49995 12L0 0L9 0L4.49995 12Z" fill="#DA2C2C" />
    </svg>
  );
};
